import { loadCacheFromLocalStorage } from '../../../helpers/localStorage';
import { ALL_COLUMNS, CACHE_KEY } from '../constants';
export const INITIAL_FILTERS = {
    values: {
        account: '',
        building: '',
        technician: null,
        technicianTeam: '',
        status: '',
        frequency: '',
        territory: '',
        buildingStatus: '',
        subcontractor: '',
        inspectionType: '',
        noAccess: '',
        zipCode: '',
        referenceNumber: '',
        workOrder: '',
        tags: '',
        tce: '',
        tceErrors: '',
        irol: '',
        irolErrors: '',
        livsafe: '',
        livsafeErrors: '',
        asset: '',
        inspectionSeries: '',
        inspectionId: '',
        iimReviewStatus: '',
        scheduledDate: {
            rangeType: 'custom_range',
            startDate: '',
            endDate: '',
            fieldType: 'dateRange'
        },
        inspectionDate: {
            rangeType: 'custom_range',
            startDate: '',
            endDate: '',
            fieldType: 'dateRange'
        }
    },
    active: {
        account: false,
        building: true,
        technician: true,
        technicianTeam: false,
        status: true,
        frequency: true,
        territory: false,
        buildingStatus: false,
        subcontractor: false,
        inspectionType: false,
        noAccess: false,
        zipCode: false,
        referenceNumber: false,
        workOrder: false,
        tags: false,
        tce: false,
        tceErrors: false,
        irol: false,
        irolErrors: false,
        livsafe: false,
        livsafeErrors: false,
        asset: true,
        scheduledDate: true,
        inspectionDate: false,
        dueDate: false,
        inspectionSeries: false,
        inspectionId: false,
        iimReviewStatus: false
    },
    operators: {
        zipCode: 'contains',
        referenceNumber: 'contains',
        workOrder: 'contains',
        inspectionId: 'contains'
    }
};
export const getInitialData = ({ cacheKey }) => {
    const cache = loadCacheFromLocalStorage(cacheKey || CACHE_KEY) || {};
    return {
        page: cache.page || { skip: 0, take: 25 },
        sort: cache.sort || [{ field: 'iimReviewStatus', dir: 'asc' }],
        filters: cache.filters || INITIAL_FILTERS,
        columns: cache.columns || ALL_COLUMNS,
        data: [],
        totalCount: 0,
        loading: false,
        cacheKey: cacheKey || CACHE_KEY
    };
};
